import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useState } from "react";
import { Grid, TextField } from "@mui/material";
import { alertService, setBackdrop } from "common-frontend-components";
import { CategorySelector } from "../../categories/SelectCategory";
import { callCreateGalleryCategoryAssociationAsync, callDeleteGalleryCategoryAssociationAsync } from "../../../../apis/galleryCategoryAssociations";
import { galleryCategoryAssociationsStore } from "../../../../stores/galleries/galleryCategoryAssociationsStore";
import { textColor } from "../../../../assets/styles/colors";
import { postCardStyle, textFieldStyle } from "../../../../assets/styles/styles";
import { callEditGalleryAsync } from "../../../../apis/galleries";
import { OrderPhotos } from "../../posts/Photos/OrderPhotos";
import { PhotoUploader } from "../../posts/Photos/PhotoUploader";
import { createGalleryIcons, createGalleryImages, PreviewImg } from "./CreateGallery";
import { IndexInput } from "../../../custom/inputs/IndexInput";
import { galleryPhotosStore } from "../../../../stores/galleries/galleryPhotosStore";
import { galleryIconsStore } from "../../../../stores/galleries/galleryIconsStore";
import { callGalleryPhotoDeletionByKeyAsync } from "../../../../apis/galleryPhotos";
import { callGalleryIconDeletionByKeyAsync } from "../../../../apis/galleryIcons";
export const EditGallery = ({ gallery, categories, onCancel, onSuccess, onGalleryUpdate, }) => {
    const [editCategories, setEditCategories] = useState(categories);
    const [edit, setEdit] = useState(gallery);
    const [photos, setPhotos] = useState([]);
    const [preview, setPreview] = useState(undefined);
    const onEditGallery = async () => {
        setBackdrop(true);
        try {
            const galleryResponse = await callEditGalleryAsync(edit.id, {
                name: edit.name,
                description: edit.description,
                index: edit.index,
            });
            onGalleryUpdate(galleryResponse);
            const categoriesToDelete = categories
                .filter(i => !editCategories.includes(i)).map(i => i.id);
            const associationsToDelete = galleryCategoryAssociationsStore.getAssociationsByGalleryId(edit.id)
                .filter(i => categoriesToDelete.includes(i.categoryId));
            await Promise.all(associationsToDelete
                .map(i => callDeleteGalleryCategoryAssociationAsync(i.id)
                .then(() => galleryCategoryAssociationsStore.setGalleryCategoryAssociations(galleryCategoryAssociationsStore.getGalleryCategoryAssociations()
                .filter(a => a.id !== i.id)))));
            const categoriesToCreate = editCategories
                .filter(i => !categories.includes(i)).map(i => i.id);
            await Promise.all(categoriesToCreate
                .map(categoryId => callCreateGalleryCategoryAssociationAsync({ categoryId, galleryId: edit.id })
                .then((a) => galleryCategoryAssociationsStore.setGalleryCategoryAssociations([a, ...galleryCategoryAssociationsStore.getGalleryCategoryAssociations()]))));
            const iconsToDelete = galleryIconsStore.getIconsById(gallery.id) || [];
            const iconsToCreate = [];
            const photosToDelete = galleryPhotosStore.getPhotosById(gallery.id) || [];
            const photosToCreate = [];
            if (preview) {
                await Promise.all(iconsToDelete
                    .map(photo => callGalleryIconDeletionByKeyAsync(photo.key)
                    .then(() => {
                    galleryIconsStore.setIcons(galleryIconsStore.getIcons()
                        .map(i => i.filter(ii => ii.key !== photo.key))
                        .filter(i => i.length !== 0));
                })));
                iconsToCreate.push({ file: new File([preview?.file], "preview.png", { type: "image/png", lastModified: Date.now() }), index: 0 });
            }
            if (photos.length > 0) {
                await Promise.all(photosToDelete
                    .map(photo => callGalleryPhotoDeletionByKeyAsync(photo.key)
                    .then(() => {
                    galleryPhotosStore.setPhotos(galleryPhotosStore.getPhotos()
                        .map(i => i.filter(ii => ii.key !== photo.key))
                        .filter(i => i.length !== 0));
                })));
                photosToCreate.push(...photos.map((file, index) => ({ file, index: index + 1 })));
            }
            await createGalleryIcons(iconsToCreate, gallery.id);
            await createGalleryImages(photosToCreate, gallery.id);
            alertService.success('your gallery has been updated =) yay!', { timeout: 4000 });
            onSuccess();
        }
        catch (e) {
            alertService.error(e);
        }
        finally {
            setBackdrop(false);
        }
    };
    return (_jsx(Box, { sx: { minWidth: 275 }, children: _jsxs(Card, { variant: "outlined", elevation: 3, sx: postCardStyle, children: [_jsxs(CardContent, { children: [_jsx(Typography, { sx: { fontSize: 16, paddingBottom: 2, color: textColor }, color: "text.secondary", gutterBottom: true, children: "Edit Gallery" }, void 0), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, children: _jsx(TextField, { sx: textFieldStyle, label: "name", variant: "outlined", value: edit.name, onChange: e => { setEdit({ ...edit, name: e.target.value }); } }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { sx: textFieldStyle, label: "description", variant: "outlined", value: edit.description || "", onChange: e => { setEdit({ ...edit, description: e.target.value }); }, fullWidth: true, multiline: true }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(PreviewImg, { preview: preview, setPreview: setPreview }, void 0) }, void 0), _jsx(OrderPhotos, { useItems: () => photos, setItems: setPhotos, parent: ({ children }) => _jsx(Grid, { item: true, xs: 12, children: children }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(PhotoUploader, { onDrop: setPhotos, usePreviewFiles: () => photos, setPreviewFiles: setPhotos }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(CategorySelector, { value: editCategories, onChange: (_, newValue) => setEditCategories(newValue) }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(IndexInput, { index: edit.index, onIndexChange: (index) => setEdit({ ...edit, index }) }, void 0) }, void 0)] }, void 0)] }, void 0), _jsx(CardActions, { children: _jsxs("div", { style: { paddingLeft: 4, paddingRight: 4 }, children: [_jsx(Button, { size: "small", onClick: onCancel, children: "Cancel" }, void 0), _jsx(Button, { size: "small", onClick: onEditGallery, children: "Save" }, void 0)] }, void 0) }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=EditGallery.js.map